import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Modal } from "react-bootstrap"
import SpChart from "components/atoms/chart/parts/SpChart"
import useChartInitialize from "components/atoms/chart/parts/useChartInitialize"
import { MODAL_CANVAS_ID } from "components/atoms/chart/logic/chartConfig"
import { changeModalVisible, changeSpModalSymbol } from "redux/ducks/Chart"
import ChartPriceDetail from "components/atoms/chart/parts/ChartPriceDetail"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import ChartLegFilter from "components/atoms/chart/parts/ChartLegFilter"
import ChartPlotFilter from "components/atoms/chart/parts/ChartPlotFilter"
import SpChartPriceDetail from "components/atoms/chart/parts/SpChartPriceDetail"
import { Labels } from "components/atoms/input/input"
import OrderBook from "components/organisms/orderBook"
import { get } from "lodash"
import { useSymbolDetail } from "components/pages/main/domestic/future"
import { NewsList } from "../../organisms/panel/newsList"
import { ROUTE_LIST } from "../../../config/const"

interface props {
  isVisible: boolean
  setVisible: Function
}

const orderBookLabel = [{ name: "チャート", id: 0 }, { name: "気配", id: 1 }]

const industryLabel = [{ name: "業種", id: 0 }, { name: "構成銘柄", id: 1 }]

const SpChartModal = () => {
  const [type, setType] = useState<0 | 1>(0)
  const canvasId = useChartInitialize({
    symbolData: {},
    chartType: "sp",
    id: MODAL_CANVAS_ID,
  })
  const dispatch = useDispatch()

  const isVisibleSelector = (state: any) =>
    state.chart[MODAL_CANVAS_ID].modalVisible
  const symbolDetailSelector = (state: any) =>
    state.chart[MODAL_CANVAS_ID].symbolDetail
  const orderBookModeSelector = (state: any) =>
    state.chart[MODAL_CANVAS_ID].orderBookMode
  const industryModeSelector = (state: any) =>
    state.chart[MODAL_CANVAS_ID].industryMode
  const symbolSelector = (state: any) => state.chart[MODAL_CANVAS_ID].symbol
  const subSymbolSelector = (state: any) =>
    state.chart[MODAL_CANVAS_ID].subSymbol

  const isVisible = useSelector(isVisibleSelector)
  const symbolDetail = useSelector(symbolDetailSelector)
  const orderBookMode = useSelector(orderBookModeSelector)
  const industryMode = useSelector(industryModeSelector)
  const symbol = useSelector(symbolSelector)
  const subSymbol = useSelector(subSymbolSelector)
  const [callSymbolDetailFuture, symbolDetailFuture] = useSymbolDetail()

  useEffect(() => {
    orderBookMode && callSymbolDetailFuture(symbolDetail)
  }, [symbolDetail])

  useEffect(() => {
    if (!industryMode || !isVisible) return
    dispatch(changeSpModalSymbol(subSymbol, false, true, symbol))
  }, [type])

  const onHide = () => {
    setType(0)
    dispatch(changeModalVisible(false))
  }

  const view_type = [
    () => {
      return (
        <>
          <div className="modal-body-items">
            <SpChartPriceDetail />
          </div>
          <div className="modal-body-items">
            <ChartLegFilter canvasId={MODAL_CANVAS_ID} />
            <ChartPlotFilter canvasId={MODAL_CANVAS_ID} isMiddle={true} />
          </div>
          <div className="modal-body-items">
            <SpChart />
          </div>
          <div className="modal-body-items">
            <InfoTable
              list={infoTableColumns.sp_modal}
              data={symbolDetail}
              className="table-striped table-index-detail"
              wrapperCls="index-detail-table-row"
            />
          </div>
        </>
      )
    },
    () => {
      return (
        <OrderBook
          push={get(symbolDetailFuture, "Symbol", {})}
          Symbol={get(symbolDetailFuture, "Symbol", {})}
          length={5}
        />
      )
    },
  ]

  return (
    <Modal
      show={isVisible}
      onHide={() => onHide()}
      dialogClassName="sp-chart-modal"
    >
      <Modal.Body>
        <div className="modal-body-content">
          {(industryMode || orderBookMode) && (
            <div className="modal-body-items btn-row">
              <Labels
                className="btn-segmented-control btn-thin liquid-control"
                labelList={orderBookMode ? orderBookLabel : industryLabel}
                checked={type}
                onChange={(id: 0 | 1) => setType(id)}
              />
            </div>
          )}
          {!industryMode ? view_type[type]() : view_type[0]()}
        </div>
        <NewsList
          route={ROUTE_LIST.DOMESTIC_INDUSTRY}
          symbol={type && get(subSymbol, "Symbol")}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-bottom-btn-row">
          <div
            className="btn btn-outline ripple"
            data-izimodal-close
            onClick={() => onHide()}
          >
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default SpChartModal
